module.exports = __webpack_public_path__ + "img/logo-dp.a6a94a5a.svg";